tailwind.config = {
  theme: {
    extend: {
      fontFamily: {
        vtc: ['VTCDuBois-Regular', 'serif'],
        'vtc-light': ['VTCDuBois-Light', 'serif'],
        'vtc-wide': ['VTCDuBois-RegularWide', 'serif'],
        'vtc-narrow': ['VTCDuBois-RegularNarrow', 'serif'],
        'vtc-bold': ['VTCDuBois-Bold', 'serif'],
        'vtc-boldWide': ['VTCDuBois-BoldWide', 'serif'],
        merchant: ['Merchant-Regular', 'serif'],
        'merchant-light': ['Merchant-Light', 'serif'],
        'merchant-medium': ['Merchant-Medium', 'serif'],
        'merchant-italic': ['Merchant-Italic', 'serif'],
      },
      animation: {
        marquee: 'marquee 25s linear infinite',
        marquee2: 'marquee2 25s linear infinite',
      },
      keyframes: {
        marquee: {
          '0%': { transform: 'translateX(0%)' },
          '100%': { transform: 'translateX(-100%)' },
        },
        marquee2: {
          '0%': { transform: 'translateX(100%)' },
          '100%': { transform: 'translateX(0%)' },
        },
      },
    },
  },
}
